import React from "react";
import styled from "styled-components";

import imagemFundo from "../../images/imagemfundo.png";
import zap from "../../images/whatsapp.png";
import Globais from "../../components/Globais";

const Container = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: #fff;
  opacity: 80%;
`;
const Imagem = styled.img`
  background-repeat: no-repeat;
  background-position: center;
  width: 70%;
`;

const ContainerTermo = styled.div`
  width: 100%;
  height: 70%;

  max-width: 30rem;
  min-width: 15rem;
  min-height: 30rem;
  max-height: 40rem;

  justify-self: flex-start;

  box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px,
    rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
  background-color: #fff;
  border-radius: 30px;
  position: absolute;
  z-index: 0;
  display: grid;
  grid-template: 10% 90%/ 100%;
  justify-content: center;
  aligm-itens: center;
`;

const TextWrapper = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;
  margin-left: 2rem;
  margin-right: 2rem;
  overflow: auto;

  flex-direction: column;
  @media (min-width: 450px) {
    margin-left: 5rem;
    margin-right: 5rem;
  }
  a {
    text-align: center;
    color: ${Globais.CorAzulBackGround};
    &:hover: {
      cursor: pointer;
    }
  }
  @media (max-height: 700px) {
    margin-top: 3rem;
  }
`;

const ContainerTitulo = styled.div`
  width: 100%;

  height: 100%;
  display: flex;
  justify-content: center;
`;

const Titulo = styled.h1`
  width: 10rem;
  text-align: center;
  align-self: center;
  color: ${Globais.CorAzulBackGround};
  margin-top: 5rem;
  font-size: 1.5rem;
  @media (min-width: 700px) {
    font-size: 1.8rem;
  }
  @media (max-width: 300px) {
    font-size: 1.3rem;
    margin-top: 10rem;
  }

  width: 80%;
`;

const H3 = styled.h3`
  text-align: center;

  color: ${Globais.CorAzulBackGround};
  font-size: 1.2rem;
  @media (min-width: 700px) {
    font-size: 1.5rem;
  }
  @media (max-height: 700px) {
    font-size: 1.2rem;
  }
  @media (max-width: 300px) {
    font-size: 0.9rem;
  }
`;
const H3Tel = styled.h3`
  text-align: center;

  color: ${Globais.CorAzulBackGround};
  font-size: 2rem;
  @media (max-width: 300px) {
    font-size: 1.5rem;
  }
`;

export default function ViewContato() {
  return (
    <Container>
      <Imagem src={imagemFundo} alt="" />
      <ContainerTermo>
        <ContainerTitulo>
          <Titulo>FALE CONOSCO</Titulo>
        </ContainerTitulo>

        <TextWrapper>
          <H3>
            Envie um e-mail para <br />
            <a href="mailto:contato@multicotas.com">
              contato@multicotas.com.br
            </a>
          </H3>

          <H3>Ou entre em contato pelo nosso Whatsapp:</H3>
          <H3Tel>(21)97273-7678</H3Tel>
          <a
            href="https://wa.me/message/H7PTB2XYZUDAO1"
            target="_blank"
            id="zap"
            rel="noreferrer"
          >
            <Imagem src={zap} />
          </a>
        </TextWrapper>
      </ContainerTermo>
    </Container>
  );
}
